import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "@scuf/common/honeywell/theme.css";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { compose, createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { combineReducer } from "./common/store/combinedReducer";
import { sagas } from "./common/store/saga";
import { configureStore } from "@reduxjs/toolkit";
import ModelPopup from "./features/components/academy/common/components/modal/modal";
import ScreenLoader from "./features/components/academy/common/components/loader/loader";
import { store } from "./store";

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const root = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <App />
        <ModelPopup />
        <ScreenLoader />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
  root
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
